import { DatePicker, TimePicker } from "antd"
import { Form, TextArea } from "formsy-semantic-ui-react"
import moment from "moment"
import ReactPixel from "react-facebook-pixel"
import TwitterConvTrkr from "react-twitter-conversion-tracker-plus"
import * as R from "ramda"
import React, { Component } from "react"
import { Button, Label } from "semantic-ui-react"
import { postPayment } from "../api/async/index"
import {
  getNotPaidParticipants,
  firePixel
} from "../api/async/participants/index"
import { getNotPaidOrders } from "../api/async/orders/index"
import { endRegisterRace, getBase64, isLogin, endEvent } from "../utils/index"
import Login from "./Login"
import Signup from "./Signup"

class ConfirmPayment extends Component {
  state = {
    targetOptions: [],
    source: "ไทยพาณิชย์",
    showLogin: !isLogin(),
    showSignup: false,
    isError: false,
    loading: false
  }

  componentDidMount = async () => {
    const notPaidParticipantRes = await getNotPaidParticipants()
    const partiOptions = notPaidParticipantRes.data
      .filter(this.filterEndRegisterTime)
      .map(each => ({
        key: `participant-${each.id}`,
        text: `${each.race_detail.race.title} - ${
          each.race_detail.distance.name
        }`,
        value: `participant-${each.id}`
      }))
    const notPaidOrderRes = await getNotPaidOrders()
    const orderOptions = notPaidOrderRes.data
      .filter(this.filterEndOrderTime)
      .map(each => ({
        key: `order-${each.id}`,
        text: `คำสั่งซื้อเลขที่ ${each.id} - ${each.event.title}`,
        value: `order-${each.id}`
      }))
    const options = partiOptions.concat(orderOptions)
    this.setState({ targetOptions: options })
    document.title = "Run24Hrs - แจ้งโอนเงิน"
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleDate = (date, dateString) => {
    if (dateString) this.setState({ paidDateError: false })
    this.setState({ paid_date: dateString }, () => this.checkErrorDateAndTime())
  }

  filterEndRegisterTime = participant =>
    !endRegisterRace(R.path(["race_detail", "race"], participant))

  filterEndOrderTime = order => !endEvent(R.path(["event"], order))

  handleTime = (date, timeString) => {
    if (timeString) this.setState({ paidTimeError: false })
    this.setState({ paid_time: timeString }, () => this.checkErrorDateAndTime())
  }

  checkErrorDateAndTime = () => {
    if (this.state.paid_date && this.state.paid_time)
      this.setState({ isError: false })
  }

  handleSubmit = () => {
    this.setState({ loading: true })
    const {
      source,
      value,
      paid_date,
      paid_time,
      image,
      target,
      note
    } = this.state
    if (!paid_date || !paid_time) {
      this.setState({ isError: true })
      if (!paid_date) this.setState({ paidDateError: true })
      if (!paid_time) this.setState({ paidTimeError: true })
      return false
    }
    const body = {
      source,
      value,
      paid_date,
      paid_time,
      image,
      note
    }
    let redirectUrl = "/me"
    if (target.includes("order")) {
      body.order = target.replace("order-", "")
      redirectUrl = "/my-order"
    } else {
      body.participant = target.replace("participant-", "")
    }
    postPayment(body).then(() => {
      if (body.participant) {
        firePixel(body.participant)
        ReactPixel.track("Purchase", {
          value,
          currency: "THB"
        })
      }
      TwitterConvTrkr.track("Purchase")
      this.props.history.push(redirectUrl)
    })
  }

  handleFile = e => {
    getBase64(e.target.files[0]).then(data => this.setState({ image: data }))
  }

  render() {
    const id = this.props.match.params.id
    const banksOption = [
      { key: 1, text: "ธนาคารไทยพาณิชย์", value: "ไทยพาณิชย์" }
    ]
    const errorLabel = <Label color="red" pointing />
    const errorLeftLabel = <Label color="red" pointing="left" />
    return (
      <React.Fragment>
        <h1>แจ้งโอนเงิน</h1>
        <p style={{ fontSize: 12 }}>
          * โอนผ่าน ธนาคาร รอตรวจสอบไม่เกิน 24 ชั่วโมง จากเวลาเเจ้งโอนเงินค่ะ
          (ชำระผ่านบัตรเครดิตไม่ต้องแจ้งโอนเงิน)
        </p>
        <p style={{ fontSize: 12 }}>* โอนเงิน เเล้วเเจ้งโอนซ้ำต่อคิวใหม่นะคะ</p>
        <p style={{ fontSize: 12 }}>
          * โอนเงิน ขาดหรือเกิน ใช้เวลาตรวจสอบนานกว่า 24 ชั่วโมงค่ะ
        </p>
        <Form
          style={{ marginBottom: "10px" }}
          onValidSubmit={this.handleSubmit}
        >
          <Form.Group>
            <Form.Select
              required
              name="target"
              value={this.state.target}
              options={this.state.targetOptions}
              placeholder="เลือกรายการที่สมัคร"
              onChange={this.handleChange}
            />
          </Form.Group>
          <Form.Group style={{ marginTop: "10px", marginBottom: "10px" }}>
            <Form.Select
              required
              name="source"
              value={this.state.source}
              onChange={this.handleChange}
              options={banksOption}
              placeholder="โอนเข้าบัญชีธนาคาร"
            />
          </Form.Group>
          <Form.Group style={{ marginTop: "10px", marginBottom: "10px" }}>
            <Form.Field
              className={{ error: this.state.paidDateError }}
              name="paid_date"
              label="วันที่โอน"
              required
              control={() => (
                <DatePicker
                  placeholder="วันที่โอน"
                  size="large"
                  value={
                    this.state.paid_date ? moment(this.state.paid_date) : null
                  }
                  onChange={this.handleDate}
                />
              )}
            />
            <Form.Field
              name="paid_date"
              label="เวลาที่โอน"
              className={{ error: this.state.paidTimeError }}
              required
              control={() => (
                <TimePicker
                  placeholder="เวลาที่โอน"
                  value={
                    this.state.paid_time
                      ? moment(this.state.paid_time, "HH:mm")
                      : null
                  }
                  format="HH:mm"
                  size="large"
                  onChange={this.handleTime}
                />
              )}
            />
          </Form.Group>
          {this.state.isError && (
            <Label
              pointing
              style={{ marginTop: "-5px", marginBottom: "5px" }}
              color="red"
            >
              โปรดระบุวันและเวลาที่โอนเงิน
            </Label>
          )}
          <Form.Group className="mb10">
            <Form.Input
              required
              validations="isNumeric"
              validationErrors={{
                isDefaultRequiredValue: "โปรดระบุจำนวนเงินที่โอน",
                isNumeric: "โปรดใส่จำนวนเงินเป็นตัวเลขเท่านั้น"
              }}
              name="value"
              icon="money"
              iconPosition="left"
              placeholder="จำนวนเงิน"
              onChange={this.handleChange}
              errorLabel={errorLabel}
            />
          </Form.Group>
          <Form.Group>
            <label className="ui button mb10 ml10" htmlFor="image-upload">
              เลือกรูป
            </label>
            <Form.Input
              required
              errorLabel={errorLeftLabel}
              validationErrors={{
                isDefaultRequiredValue: "กรุณาแนบรูปหลักฐานการโอนเงิน"
              }}
              style={{ display: "none" }}
              id="image-upload"
              name="image"
              type="file"
              icon="money"
              iconPosition="left"
              onChange={this.handleFile}
            />
          </Form.Group>
          {this.state.image && (
            <img className="ui large image mb10" src={this.state.image} />
          )}
          <Form.Group style={{ marginTop: "10px", marginBottom: "10px" }}>
            <TextArea
              name="note"
              style={{ width: "225px" }}
              placeholder="รายละเอียดเพิ่มเติม&#10;(เว้นว่างได้)"
              onChange={e => this.setState({ note: e.target.value })}
              value={this.state.note}
            />
          </Form.Group>
          <Button
            className="ui teal"
            type="submit"
            {...this.state.loading && { loading: true, disabled: true }}
          >
            ส่งหลักฐานโอนเงิน
          </Button>
        </Form>
        <Login
          open={this.state.showLogin}
          onClose={() => this.setState({ showLogin: false })}
          closeOnDimmerClick={false}
          closeOnEscape={false}
          toggleSignup={() => {
            this.setState({ showLogin: false })
            this.setState({ showSignup: true })
          }}
        />
        <Signup
          open={this.state.showSignup}
          onClose={() => this.setState({ showSignup: false })}
        />
      </React.Fragment>
    )
  }
}

export default ConfirmPayment



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/ConfirmPayment.js